import classcat from "classcat";
import React from "react";
import Drawer from "react-modern-drawer";

import { Button, IconRefresh, IconStar } from "@touchtech/web-baselayer-ui";

import { DRAWER_STYLES } from "@is/constants/preferences";

import { Logo } from "../Logo";
import RestartSearchModal from "../RestartSearchModal";
import css from "./Footer.module.css";
import useManageFooter from "./hooks/useManageFooter";

type Props = {
  isOpen: boolean;
  onClose?: () => void;
  enableOverlay?: boolean;
  styles?: { [key: string]: string };
  borderTop?: boolean;
  onLogoClick?: () => void;
  onStoreFavoritesClick?: () => void;
  showStoreFavoritesButton?: boolean;
  showRestartSessionButton?: boolean;
  enableStaffDashboard?: boolean;
  inDrawer?: boolean;
  isMinimized?: boolean;
};

const Footer = ({
  isOpen,
  onClose,
  enableOverlay = true,
  styles = DRAWER_STYLES,
  borderTop = true,
  onLogoClick,
  onStoreFavoritesClick,
  showStoreFavoritesButton = false,
  showRestartSessionButton = true,
  enableStaffDashboard = true,
  inDrawer = true,
  isMinimized = false,
}: Props) => {
  const {
    t,
    handleLogoClick,
    handleRestartClick,
    handleOpenModal,
    handleCloseModal,
    showConfirmationModal,
  } = useManageFooter({ onLogoClick });

  const FooterContent = (
    <div
      className={classcat([
        css.container,
        {
          [css.active]: isOpen,
          [css.borderTop]: borderTop,
          [css.sticky]: isMinimized,
        },
      ])}
    >
      <div className={classcat([{ [css.buttonContainer]: !isMinimized }])}>
        {showRestartSessionButton && (
          <Button
            variant="tertiary"
            sizing="lg"
            width="full"
            className={css.startSearchButton}
            onClick={handleOpenModal}
          >
            <IconRefresh className="text-label-2xl" />
            {!isMinimized && t("Reset Search")}
          </Button>
        )}
      </div>
      <Logo
        onClick={enableStaffDashboard ? handleLogoClick : undefined}
        logoClassName={css.logoClassName}
      />
      <div className={classcat([{ [css.buttonContainer]: !isMinimized }])}>
        {showStoreFavoritesButton && (
          <Button
            variant="tertiary"
            sizing="lg"
            width="full"
            className={css.startSearchButton}
            onClick={onStoreFavoritesClick}
          >
            <IconStar className="text-label-2xl" />
            {!isMinimized && t("Store favorites")}
          </Button>
        )}
      </div>
      {showConfirmationModal && (
        <RestartSearchModal
          onRestart={handleRestartClick}
          onClose={handleCloseModal}
        />
      )}
    </div>
  );

  if (inDrawer) {
    return (
      <Drawer
        open={isOpen}
        size="auto"
        onClose={onClose}
        direction="bottom"
        enableOverlay={enableOverlay}
        overlayOpacity={0}
        style={styles}
      >
        {FooterContent}
      </Drawer>
    );
  } else {
    return FooterContent;
  }
};

export default Footer;
